<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div>
      <p class="navadno-besedilo">
        Klice lahko preusmerite na katerokoli stacionarno ali mobilno številko, lahko pa jih preusmerite tudi
        na telefonski odzivnik. Uporabite lahko različne profile. Pri preusmeritvah se klici obračunavajo po
        ceniku, in sicer kot klic iz domačega T-2 omrežja v omrežje preusmerjene telefonske številke.
        Preusmeritev je možno vključiti na slovenske in tuje telefonske številke, a svetujemo previdnost
        pri preusmeritvah na tuje številke.
      </p>
      <p class="navadno-besedilo">
        Več o uporabi preusmeritev
        <a :href="povezavaPreusmeritevNaStacionarnihTelefonskihStevilkah" class="primarna-barva">tukaj</a>.
      </p>
    </div>
    <div style="padding-top: 20px">
      <div>
        <img src="/static/img/Nastavitve/Telefonija/Icon-material-subdirectory-arrow-right.png"
             width="24.1" height="24.1" style="float: left">
        <p class="open-sans-20pt moji-profili" style="float: left; padding-left: 10px">
          Moji profili preusmeritev in nastavitve
        </p>
      </div>
      <div style="clear: both"/>
    </div>
    <div class="podatki" style="padding-bottom: 10px">
      <div>
        Izberi profil
        <el-select v-model="izbranProfil" class="velikost-izbire-profila" v-loading="nalaganjePodatkov">
          <el-option v-for="(profil) in profili.slice(0, this.profili.length -1)"
                     :value="profil.name"
                     :label="profil.name"
                     :key="profil.id"
                     :name="profil.name">
            {{ profil.name }}
          </el-option>
        </el-select>
      </div>
      <div class="center-div" style="padding-top: 10px">
        <el-checkbox v-model="aktivenProfil">
          <p :class="aktivenProfil ? 'navadno-besedilo krepko' : 'navadno-besedilo'">
            Profil je aktiven
          </p>
        </el-checkbox>
      </div>
      <div class="center-div" style="padding-top: 10px" v-if="!this.aktivenProfil && this.izbranProfil !== 'Privzeti profil'">
        <a class="stil-gumb-preklici" @click="IzbrisiProfil(izbranProfil, aktivenProfil)">
          <i class="fa fa-trash" style="font-size: 16px"></i>
          ODSTRANI PROFIL
        </a>
      </div>
    </div>
    <div class="postavitev-tabele-preusmeritev">
      <div v-loading="nalaganjePodatkov">
        <el-table
          :data="infoOPreusmeritvah.rules"
          @expand-change="Izbranavrstica"
          :expand-row-keys="expandRowKeys"
          :row-key="row => row.ImeVSlo"
          style="width: 100%">
          <el-table-column
            min-width="80"
            label="Preusmeritev">
            <template slot-scope="scope">
              {{ scope.row.ImeVSlo }}
            </template>
          </el-table-column>
          <el-table-column label="Nabor številk" min-width="60">
            <template slot-scope="scope">
              Vse
            </template>
          </el-table-column>
          <el-table-column label="Preusmeritev na">
            <template slot-scope="scope">
              <div v-if="typeof scope.row.phoneNumber !== 'undefined' && scope.row.name !== 'Glasovna pošta'">
                {{ scope.row.phoneNumber }}
              </div>
              <div v-else>
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Status" align="center" min-width="40">
            <template slot-scope="scope">
              <div v-if="scope.row.status === true">
                <img src="/static/img/kljukica.png" >
              </div>
              <div v-else>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="gumb-forma">
                <div v-if="scope.row.ImeVSlo === 'Zavrni klice'">
                  <el-form label-width="200px" :label-position="formaOrientacija" class="forma-preusmeritev">
                    <el-form-item  label="Vklopi:">
                      <el-checkbox v-model="prviObjektPreusmeritve.aktivniStatus"/>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-else>
                  <el-form label-width="200px" :label-position="formaOrientacija" class="forma-preusmeritev">
                    <el-form-item label="Preusmeritev na:">
                      <el-select v-model="scope.row.name = prviObjektPreusmeritve.name" class="velikost-vnosnega-polja">
                        <el-option
                          v-for="poz in prviObjektPreusmeritve.keys"
                          :key="poz"
                          :label="poz"
                          :value="poz">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Vnesite telefonsko številko:" v-if="scope.row.name === 'Telefonska številka'">
                      <el-input class="velikost-vnosnega-polja" placeholder="Format: 38664100100" :maxlength="11"
                                v-model="scope.row.phoneNumber = prviObjektPreusmeritve.phoneNumber">
                      </el-input>
                      <p v-bind:class="{'text-warning': narobeSt}"
                         v-if="narobeSt === true">
                        Vnesite pravilno telefonsko številko
                      </p>
                    </el-form-item>
                    <el-form-item label="Vklopi:">
                      <el-checkbox v-model="scope.row.status"/>
                    </el-form-item>
                    <el-form-item label="Počakaj sekund:"  v-if="imePreusmeritve === 'Ko ni odgovora' && scope.row.name === 'Telefonska številka'">
                      <el-select v-model="scope.row.timeout">
                        <el-option
                          v-for="poz in timeOutSeconds"
                          :label="poz + ' sekund'"
                          :value="poz"
                          :key="poz">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding-top: 20px">
          <el-button class="gumb-potrdi mobile-gumb" @click="ShraniSpremembe">
            SHRANI SPREMEMBE
          </el-button>
        </div>
        <div>
          <InfoOknoPreusmeritve/>
        </div>
      </div>
      <div>
        <hr class="hr-stil nova-crta">
      </div>
      <div>
        <p class="open-sans-20pt moji-profili" style="float: left">
          Dodajanje profilov
        </p>
      </div>
      <div class="preusmeritve-nov-profil">
        <el-form>
          <div class="postavitev-ustvari-nov-nosilec">
            <el-form-item label="Vpiši ime novega profila" placeholder="Vnesite naziv nosilca">
              <el-input v-model="imeNovegaProfila" class="vpis-novega-nosilca">
              </el-input>
            </el-form-item>
          </div>
          <div style="padding-top: 25px">
            <el-button class="gumb-potrdi" @click="PrikazZaUstvarjanjeNovegaProfila">
              USTVARI NOV PROFIL
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div style="padding-top: 40px">
      <hr class="hr-stil">
    </div>
    <div style="padding-top: 40px" v-loading="nalaganjeUrnikov">
      <div>
        <img src="/static/img/Nastavitve/Telefonija/Icon-awesome-clock.png" width="20"
             height="20" style="float: left; margin-top: 4px;">
        <p class="open-sans-20pt moji-profili" style="float: left; padding-left: 10px">
          Tedenski urnik preusmeritev
        </p>
      </div>
      <div style="clear: both"/>
      <div style="padding-top: 30px">
        <p class="navadno-besedilo">
          Z urnikom lahko določite časovni termin, ko želite, da je določena preusmeritev aktivna. <br>
          Izberete lahko do 5 časovnih območij in znotraj razporedite izbrane profile.
          Posodobitve se izvajajo vsakih 5 minut.<br>
          Več o uporabi urnikov
          <a :href="aliLahkoNastavimPreusmeritevKlicev" class="primarna-barva">
            tukaj
          </a>. <br>
        </p>
      </div>
      <div>
        <div style="padding-top: 30px; color:black" class="urnik-checkbox">
                <span class="odmik-desno">
                  Stanje urnika:
                </span>
          <el-radio v-model="vkljucenUrnik" :label=true :class="vkljucenUrnik ? 'krepko' : 'crna'">
            Vključen
          </el-radio>
          <el-radio v-model="vkljucenUrnik" :label=false :class="vkljucenUrnik !== true ? 'krepko' : 'crna'">
            Izključen
          </el-radio>
        </div>
      </div>
      <div style="padding-top: 50px; border-bottom: 1px solid #d8dce6;" v-if="vkljucenUrnik">
        <el-table :data="urniki"
                  v-loading="nalaganjeUrnikov"
                  :key="urnikTabelaKey"
                  :cell-class-name="UrnikiCellClass"
                  style="width: 100%"
                  :header-cell-style="{verticalAlign: 'top'}">
          <el-table-column
            min-width="50"
            label="Dan"
            prop="imeDneva">
          </el-table-column>
          <el-table-column
            align="left"
            min-width="80"
            label="Izbran profil">
            <template slot-scope="props">
              <div v-for="urnik in props.row.urniki" class="posamezenUrnik">
                <el-select v-model="urnik.profileId"
                           @change="PreracunajPodatkeUrnikov()">
                  <el-option v-for="profil in profili"
                             v-if="profil.id > 0"
                             :value="profil.id"
                             :label="profil.name"
                             :key="profil.id"
                             :name="profil.name"
                             style="width: 100%">
                  </el-option>
                </el-select>
              </div>
              <a href="#"
                 @click="DodajanjeNovegaIntervala
                  (props.row.zaporedniDan,'00:00','23:55',false)"
                 class="primarna-barva">
                Dodaj časovno območje
              </a>
            </template>
          </el-table-column>
          <el-table-column
            min-width="75"
            align="left"
            label="Aktivno od">
            <template slot-scope="props"
                      class="testniClass">
              <div v-for="urnik in props.row.urniki" class="posamezenUrnik">
                <el-time-select
                  class="aktivno-od"
                  arrow-control="true"
                  placeholder="Ura od"
                  v-model="urnik.dateFrom"
                  format="HH:mm"
                  value-format="HH:mm"
                  :clearable=false
                  :picker-options="{start: '00:00',step: '00:05',end: '23:55' }">
                </el-time-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="75"
            label="Aktivno do">
            <template slot-scope="props"
                      class="testniClass">
              <div v-for="urnik in props.row.urniki" class="posamezenUrnik">
                <el-time-select
                  class="aktivno-do"
                  arrow-control
                  placeholder="Ura od"
                  v-model="urnik.dateTo"
                  format="HH:mm"
                  value-format="HH:mm"
                  :clearable=false
                  :picker-options="{start: '00:00',step: '00:05',end: '23:55' }">
                </el-time-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="25"
            align="center">
            <template slot-scope="props">
              <div v-for="(urnik, index) in props.row.urniki" class="posamezenUrnik">
                <a style="cursor: pointer">
                  <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png"
                       @click="OdstraniIntervarlIzUrnika(urnik.day, index)">
                </a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="padding-top: 40px">
        <el-button class="gumb-potrdi" @click="ShraniUrnikePreusmeritev">
          SHRANI NASTAVITVE URNIKA
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from '../../../../../../assets/js/Povezave/povezave'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {
  Tabs, TabPane, Select, Option, Button, Checkbox, Input, Tooltip, Table, TimeSelect, CollapseItem,
  Collapse, TimePicker, MessageBox
} from 'element-ui'
import ClientAgent from '../../../../../../assets/js/clientAgent.js'
import InfoOknoPreusmeritve from '../NastavitveMobilnaTelefonija/InfoOknoPreusmeritve.vue'

export default {
  name: 'PreusmeritevStacionarnaTelefonija',
  mixins: [SirinaOkna, PrikazVsebine],
  data () {
    return {
      clientAgent: null,
      aktivenProfil: false,
      formaOrientacija: 'left',
      mejnaSirina: 1200,
      profili: [],
      profiliIdNameMapiranje: [],
      izbranProfil: '',
      imeNovegaProfila: '',
      ustvarjanjeProfila: false,
      idProfil: '',
      nalaganjePodatkov: false,
      vkljucenUrnik: false,
      imePreusmeritve: '',
      selectedTimeOut: 1,
      timeOutSeconds: [],
      izbranaPreusmertive: '',
      infoOPreusmeritvah: [],
      telStevilkPreusmeritve: '',
      prviObjektPreusmeritve: [],
      drugiAnonimenObjektPreusmeritve: {},
      urnikTabelaKey: null,
      expandRowKeys: [],
      imenaDnevov: {
        0: 'Ponedeljek',
        1: 'Torek',
        2: 'Sreda',
        3: 'Četrtek',
        4: 'Petek',
        5: 'Sobota',
        6: 'Nedelja in prazniki'
      },
      urniki: [],
      narobeSt: false,
      nalaganjeUrnikov: false,
      povezavaPreusmeritevNaStacionarnihTelefonskihStevilkah: '',
      aliLahkoNastavimPreusmeritevKlicev: ''
    }
  },
  props: {
    izbranPrikljucek: String,
    izbranaTelefonska: String,
    jeStatusOdzivnika: Boolean
  },
  components: {
    InfoOknoPreusmeritve,
    [Table.name]: Table,
    [TimeSelect.name]: TimeSelect,
    [Tooltip.name]: Tooltip,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [TimePicker.name]: TimePicker
  },
  watch: {
    izbranaTelefonska: function () {
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        this.GetPreusmeritve()
        this.PridobiUrnikePreusmeritev()
      }
    },
    izbranProfil: function () {
      this.PrikazIzbranegaProfila(this.izbranProfil)
    },
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    vkljucenUrnik: function () {
      if (this.vkljucenUrnik === true) {
        for (let i = 0; i <= 6; i++) {
          if (this.urniki[i].urniki.length !== 0) {
            return 0
          }
        }
        this.DodajPrivzeteIntervale()
      }
    }
  },
  mounted () {
    this.izprazniUrnike()
    this.urnikTabelaKey = 0
    this.clientAgent = new ClientAgent()
    this.PridobiUrnikePreusmeritev()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.povezavaPreusmeritevNaStacionarnihTelefonskihStevilkah =
      povezave.BASE_URL_PREUSMERITEV_NA_STACIONARNIH_TELEFONSKIH_STEVILKAH
    this.aliLahkoNastavimPreusmeritevKlicev = povezave.BASE_URL_NASTAVITEV_PREUSMERITVE_KLICEV
    this.GetPreusmeritve()
    this.IzbirnikSekund()
  },
  methods: {
    IzbirnikSekund () {
      this.timeOutSeconds = []
      for (let i = 5; i <= 30; i = i + 5) {
        this.timeOutSeconds.push(i)
      }
    },
    DodajPrivzeteIntervale () {
      this.izprazniUrnike()
      for (let i = 0; i <= 6; i++) {
        this.DodajanjeNovegaIntervala(i, '00:00', '08:00', true)
        this.DodajanjeNovegaIntervala(i, '08:00', '16:00', true)
        this.DodajanjeNovegaIntervala(i, '16:00', '23:55', true)
      }
    },
    GetPreusmeritve () {
      this.nalaganjePodatkov = true
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/getPreusmeritve?',
          param,
          null,
          'PridobljeniPodatkiPreusmeritve',
          'ErrPridobljeniPodatkiPreusmeritve')
      }
    },
    PridobljeniPodatkiPreusmeritve (podatki) {
      this.profiliIdNameMapiranje = []
      this.profili = []
      this.izbranProfil = ''
      this.profili = podatki.data
      for (let i = 0; i < this.profili.length; i++) {
        if (this.profili[i].name === 'My default rules') {
          this.profili[i].name = 'Privzeti profil'
        }
        if (this.profili[i].status === true) {
          this.izbranProfil = this.profili[i].name
        }
        if (typeof this.profili[i].name === 'string') {
          this.profiliIdNameMapiranje[this.profili[i].id] = this.profili[i].name
        }
        this.profili[i].profileName = this.profili[i].name
      }
      if (this.izbranProfil === '') {
        this.izbranProfil = this.profili[0].name
      }
      this.DodanaLasnostVSloJeziku()
      this.PrikazIzbranegaProfila(this.izbranProfil)
      this.expandRowKeys = []
      this.nalaganjePodatkov = false
    },
    ErrPridobljeniPodatkiPreusmeritve (podatki) {
      this.ShowWarningMessage(podatki)
    },
    Izbranavrstica (row, expandedRows) {
      const id = row.ImeVSlo
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      if (expandedRows.length > 0) {
        this.NastavitevPodatkov(row)
      }
    },
    DodanaLasnostVSloJeziku () {
      for (let i = 0; i < Object.keys(this.profili).length - 1; i++) {
        for (let prompt in this.profili[i].rules) {
          if (this.profili[i].rules[prompt].rulename === 'unconditional') {
            this.profili[i].rules[prompt].ImeVSlo = 'Brezpogojno'
          } else if (this.profili[i].rules[prompt].rulename === 'anonymous') {
            this.profili[i].rules[prompt].ImeVSlo = 'Anonimno'
          } else if (this.profili[i].rules[prompt].rulename === 'noAnswer') {
            this.profili[i].rules[prompt].ImeVSlo = 'Ko ni odgovora'
          } else if (this.profili[i].rules[prompt].rulename === 'busy') {
            this.profili[i].rules[prompt].ImeVSlo = 'Ob zasedenosti'
          } else if (this.profili[i].rules[prompt].rulename === 'reject') {
            this.profili[i].rules[prompt].ImeVSlo = 'Zavrni klice'
          } else if (this.profili[i].rules[prompt].rulename === 'failure') {
            this.profili[i].rules[prompt].ImeVSlo = 'Ob napaki'
          } else if (this.profili[i].rules[prompt].rulename === 'CallForwardNotReach') {
            this.profili[i].rules[prompt].ImeVSlo = 'Ob nedosegljivosti'
          }
        }
      }
    },
    PreveriDaNiEnakegaImenaInCrke () {
      if (this.profili !== null) {
        for (let i = 0; i < Object.keys(this.profili).length; i++) {
          if (this.imeNovegaProfila === this.profili[i].name) {
            return false
          }
        }
      }
      let regex = new RegExp('^([a-zA-Z0-9 ]+)$')
      this.imeNovegaProfila.trim()
      let presledki = new RegExp('^$|^\\S+.*')
      if (regex.test(this.imeNovegaProfila) === true && presledki.test(this.imeNovegaProfila) === true) {
        return true
      } else {
        return false
      }
    },
    UstvariNovProfil () {
      if (Object.keys(this.profili).length <= 5 && this.PreveriDaNiEnakegaImenaInCrke() !== false) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        param.push('imeProfil=' + this.imeNovegaProfila)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/ustvariProfil?',
          param,
          null,
          'SetUstvarjenNovProfil',
          'ErrUstvarjenNovProfil')
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Dovoljenih je največ 5 profilov ali napacno ime'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    ErrUstvarjenNovProfil (podatki) {
      this.ShowWarningMessage(podatki)
    },
    SetUstvarjenNovProfil () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno ustvarjen nov profil'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetPreusmeritve()
      this.imeNovegaProfila = ''
      this.ustvarjanjeProfila = false
    },
    ErrtShraniSoglasja (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PrikazZaUstvarjanjeNovegaProfila () {
      if (this.ustvarjanjeProfila === false) {
        this.ustvarjanjeProfila = true
        if (Object.keys(this.profili).length < 6) {
          this.UstvariNovProfil()
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Najvec 5 profilov dovoljenih.'
          this.ShowWarningMessage(paramObvestilo)
          this.ustvarjanjeProfila = false
        }
      }
    },
    IzbrisiProfil (profil) {
      for (let prompt in this.profili) {
        if (this.profili[prompt].name === profil) {
          this.idProfil = this.profili[prompt].id
          this.izbranProfil = profil
          break
        }
      }
      MessageBox.confirm(
        'Ali ste prepričani, da želite izbrisati izbran profil ' + this.izbranProfil + '?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        param.push('idProfil=' + this.idProfil)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/izbrisiProfil?',
          param,
          null,
          'SetIzbrisiProfil',
          'ErrIzbrisiProfi')
      }).catch((err) => {
        err = null
      })
    },
    SetIzbrisiProfil () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno izbrisan profil.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetPreusmeritve()
      this.PridobiUrnikePreusmeritev()
    },
    ErrIzbrisiProfi (podatki) {
      this.ShowWarningMessage(podatki)
    },
    NastavitevPodatkov (objectPreusmertive) {
      this.narobeSt = false
      this.prviObjektPreusmeritve = []
      this.imePreusmeritve = ''
      this.telStevilkPreusmeritve = ''
      this.drugiAnonimenObjektPreusmeritve = {}
      this.imePreusmeritve = objectPreusmertive.ImeVSlo
      this.prviObjektPreusmeritve = JSON.parse(JSON.stringify(objectPreusmertive))
      this.telStevilkPreusmeritve = this.prviObjektPreusmeritve.phoneNumber
      if (this.imePreusmeritve === 'Ko ni odgovora') {
        if (this.selectedTimeOut === 0 || this.selectedTimeOut === 1) {
          this.selectedTimeOut = 1
          this.prviObjektPreusmeritve.timeout = 1
        }
      }
      if (this.imePreusmeritve === 'Brezpogojno') {
        for (let i = 0; i < this.infoOPreusmeritvah.rules.length; i++) {
          if (this.infoOPreusmeritvah.rules[i].ImeVSlo === 'Anonimno') {
            this.drugiAnonimenObjektPreusmeritve = JSON.parse(JSON.stringify(this.infoOPreusmeritvah.rules[i]))
            break
          }
        }
      }
    },
    ShraniSpremembe () {
      for (let i = 0; i < this.infoOPreusmeritvah.rules.length; i++) {
        this.infoOPreusmeritvah.rules[i].type = ''
        if (this.infoOPreusmeritvah.rules[i].name === 'Telefonska številka') {
          this.infoOPreusmeritvah.rules[i].type = 'PHONE_NUMBER'
        } else if (this.infoOPreusmeritvah.rules[i].name === 'Glasovna pošta') {
          this.infoOPreusmeritvah.rules[i].type = 'VOICEMAIL'
          this.infoOPreusmeritvah.rules[i].phoneNumber = ''
        } else if (this.infoOPreusmeritvah.rules[i].name === 'Omrežje') {
          this.infoOPreusmeritvah.rules[i].type = 'NETWORK'
        }
      }
      this.UrejanjeProfila()
      this.GetPreusmeritve()
    },
    PrikazIzbranegaProfila (profil) {
      this.aktivenProfil = false
      this.izbranProfil = profil
      this.infoOPreusmeritvah = []
      for (let prompt in this.profili) {
        if (this.profili[prompt].name === profil) {
          this.aktivenProfil = this.profili[prompt].status
          let izbraniProfil = null
          izbraniProfil = this.profili[prompt]
          this.infoOPreusmeritvah = izbraniProfil
          this.izbranProfil = izbraniProfil.name
          if (this.jeStatusOdzivnika === true) {
            izbraniProfil.rules.forEach(function (e) {
              e.type = ''
              if (e.ImeVSlo === 'Anonimno') {
                e.keys = ['Glasovna pošta', 'Omrežje']
              } else if (e.ImeVSlo === 'Zavrni klice') {
              } else {
                e.keys = ['Glasovna pošta', 'Telefonska številka']
              }
              if (e.name === 'Glasovna pošta') {
                e.name = 'Glasovna pošta'
                e.type = 'VOICEMAIL'
                delete e.phoneNumber
              }
              if (e.name === 'Telefonska številka') {
                e.name = 'Telefonska številka'
                e.type = 'PHONE_NUMBER'
              }
            })
            this.infoOPreusmeritvah = izbraniProfil
          } else {
            izbraniProfil.rules.forEach(function (e) {
              if (e.ImeVSlo === 'Anonimno') {
                e.keys = ['Omrežje']
              } else if (e.ImeVSlo === 'Zavrni klice') {
              } else {
                e.keys = ['Telefonska številka']
              }
              if (e.name === 'Telefonska številka') {
                e.name = 'Telefonska številka'
                e.type = 'PHONE_NUMBER'
              }
            })
            this.infoOPreusmeritvah = izbraniProfil
          }
        }
      }
    },
    UrejanjeProfila () {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('idProfil=' + this.infoOPreusmeritvah.id)
      param.push('status=' + this.aktivenProfil)
      param.push('stevilka=' + this.izbranaTelefonska)
      if (this.infoOPreusmeritvah.rules[2].timeout === 0) {
        this.infoOPreusmeritvah.rules[2].timeout = 1
      }
      param.push('preusmeritve=' + JSON.stringify(this.infoOPreusmeritvah.rules))
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/telefonija/urediProfil?',
        param,
        null,
        'SetUspesnoUrejanjeProfila',
        'ErrUspesnoUrejanjeProfila')
    },
    SetUspesnoUrejanjeProfila () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljene preusmeritve.'
      this.ShowSuccessMessage(paramObvestilo)
      this.PrikazIzbranegaProfila(this.izbranProfil)
      this.GetPreusmeritve()
    },
    ErrUspesnoUrejanjeProfila (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PreveriTelStevilka (telStevilka) {
      let regex = new RegExp('^(3861237)[0-1][0-9]1[2,3]{1}$')
      let regex2 = new RegExp('^(0)[0-9]{7}[0-9]{1}$')
      let regex3 = new RegExp('^(\\d)\\1*$')
      let regex4 = new RegExp('^(386)[0-9]{7}[0-9]{1}$')
      if ((telStevilka.length === 9 || telStevilka.length === 11) &&
        (regex.test(telStevilka) === false && regex3.test(telStevilka) === false) &&
        (regex2.test(telStevilka) === true ||
          regex4.test(telStevilka) === true)) {
        return true
      } else {
        return false
      }
    },

    UrnikiCellClass ({row, column, rowIndex, columnIndex}) {
      if (columnIndex > 0) {
        return 'vertical-align-top'
      }
      return ''
    },
    izprazniUrnike () {
      this.urniki = []
      for (let dan in this.imenaDnevov) {
        this.urniki.push({imeDneva: this.imenaDnevov[dan], zaporedniDan: dan, urniki: []})
      }
    },
    PridobiUrnikePreusmeritev () {
      if (this.izbranPrikljucek !== '') {
        this.nalaganjeUrnikov = true
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/pridobiUrnike?',
          param,
          null,
          'PridobljeniPodatkiUrnikPreusmeritve',
          'ErrPridobljeniPodatkiUrnikPreusmeritve')
      }
    },
    PridobljeniPodatkiUrnikPreusmeritve (podatki) {
      this.izprazniUrnike()
      let urniki = this.urniki
      podatki.data.forEach(function (value) {
        urniki[value.day].urniki.push(value)
      })
      this.vkljucenUrnik = podatki.data.length > 0
      this.urniki = urniki
      this.PreracunajPodatkeUrnikov(false)
      this.nalaganjeUrnikov = false
    },
    ErrPridobljeniPodatkiUrnikPreusmeritve (podatki) {
      this.ShowWarningMessage(podatki)
    },
    ShraniUrnikePreusmeritev () {
      if (!this.vkljucenUrnik) {
        this.izprazniUrnike()
      }
      let errorMsg = null
      let params = ['idPrikljucek=' + this.izbranPrikljucek]
      params.push('stevilka=' + this.izbranaTelefonska)
      for (let dan in this.urniki) {
        this.urniki[dan].urniki.forEach(urnik => {
          params.push('urniki[]=' + JSON.stringify(urnik))
          if (urnik.profileId === null) {
            errorMsg = 'Vsi urniki morajo imeti označen profil!'
          }
        })
      }
      if (errorMsg === null) {
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/shraniUrnike?',
          params,
          null,
          'UrnikShranjenUspesno',
          'UrnikNiShranjen')
      } else {
        this.ShowWarningMessage({message: errorMsg})
      }
    },
    UrnikShranjenUspesno (podatki) {
      this.PridobiUrnikePreusmeritev()
      this.GetPreusmeritve()
      this.ShowSuccessMessage({message: podatki.message})
    },
    UrnikNiShranjen (podatki) {
      this.ShowWarningMessage({message: podatki.message})
    },
    pridobiImeProfila (idProfila) {
      return this.profiliIdNameMapiranje[idProfila]
    },
    PreracunajPodatkeUrnikov (spremeniImenaUrnikov = true) {
      for (let dan in this.urniki) {
        let urnikiZaDan = []
        for (let zaporedniUrnik in this.urniki[dan].urniki) {
          zaporedniUrnik = parseInt(zaporedniUrnik)
          let urnik = this.urniki[dan].urniki[zaporedniUrnik]
          if (spremeniImenaUrnikov === true) {
            urnik['profileName'] = this.pridobiImeProfila(urnik['profileId'])
          }
          urnik.sort = parseInt(urnik['dateFrom'].replace(':', ''))
          urnikiZaDan.push(urnik)
        }
        urnikiZaDan.sort((a, b) => a.sort - b.sort)
        for (let zaporedniUrnik in urnikiZaDan) {
          zaporedniUrnik = parseInt(zaporedniUrnik)
          urnikiZaDan[zaporedniUrnik]['obmocje'] = zaporedniUrnik
          if ((urnikiZaDan.length - 1) === zaporedniUrnik) {
            urnikiZaDan[zaporedniUrnik]['dateTo'] = '23:55'
          } else {
            urnikiZaDan[zaporedniUrnik]['dateTo'] = urnikiZaDan[(zaporedniUrnik + 1)]['dateFrom']
          }
        }
        this.urniki[dan].urniki = urnikiZaDan
      }
      this.urnikTabelaKey += 1
    },
    DodajanjeNovegaIntervala (dan, uraOd, uraDo, privzetaVrednost) {
      let novUrnik = {
        active: true,
        dateFrom: uraOd,
        dateTo: uraDo,
        day: dan,
        profileId: null,
        profileName: 'Privzeti profil',
        scheduleId: null
      }
      this.urniki[dan].urniki.push(novUrnik)
      this.PreracunajPodatkeUrnikov()
    },
    OdstraniIntervarlIzUrnika (day, index) {
      if (this.urniki !== null) {
        this.urniki[day].urniki.splice(index, 1)
        this.PreracunajPodatkeUrnikov()
      }
    }
  }
}
</script>
<style scoped
       src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveStacionarnaTelefonija/Preusmeritve.css">
</style>
<style src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveStacionarnaTelefonija/Urniki.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveStacionarnaTelefonija/PreusmeritevStacionarnaTelefonija.vue